import { Pipe, PipeTransform } from '@angular/core';
import { FormatterUtils } from '../utils/formatter.utils';

@Pipe({
  name: 'formatNumber',
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: any) {
    return FormatterUtils.formatNumber(value);
  }
}
